import React, { useRef } from 'react';
import Slider from 'react-slick';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'; // Arrow icons for navigation

// Card component
const Card = ({ title, description }) => {
  return (
    <div className="card">
      <h3 style={{marginRight:"100px"}}>{title}</h3>
      <p>{description}</p>
      <style jsx>{`
        .card {
          width: 350px; /* Increased width */
          height: 150px; /* Decreased height */
          padding: 20px;
          margin: 10px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 6px 24px rgba(0, 0, 0, 0.1);
          text-align: center;
          background-color: #fff;
          transition: transform 0.3s ease, background-color 0.3s ease; /* Add transition for color */
          cursor: pointer;
        }

        .card:hover {
          transform: scale(1.05);
          background-color: #038499; /* Keep the color after hover */
          color: white; /* Change text color to white for better visibility */
        }

        h3 {
          font-size: 22px;
          color: #333;
        }

        p {
          font-size: 16px;
          color: #777;
        }
      `}</style>
    </div>
  );
};

// Main component with Slick Slider and Auto-scrolling functionality
const GroupCompanies = () => {
  const sliderRef = useRef(null); // Ref to control slider programmatically

  // Settings for the slick slider with auto-scrolling enabled
  const sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000, // Auto-scroll speed (2 seconds)
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Function to manually scroll to the next slide
  const goToNextSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  // Function to manually scroll to the previous slide
  const goToPrevSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  return (
    <div className="app-container" style={{ background: '#fff' }}>
      <br />
      <h2>
        <span style={{ color: '#000' }}>Group</span> Companies
      </h2>

      {/* Slick Slider */}
      <Slider {...sliderSettings} ref={sliderRef} className="cards-slider">
        <Card title="ENVISION" />
        <Card title="I-ROBOTS" />
        <Card title="ENVISION" />
        <Card title="I-ROBOTS" />
        <Card title="ENVISION" />
      </Slider>

      {/* Button Container for Manual Navigation */}
      <div className="buttons-container">
        <button onClick={goToPrevSlide} className="arrow-button prev-button">
          <FaArrowLeft />
        </button>
        <button onClick={goToNextSlide} className="arrow-button next-button">
          <FaArrowRight />
        </button>
      </div>

      <style jsx>{`
        .app-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-color: #f4f4f4;
          padding: 20px;
        }

        .cards-slider {
          margin-bottom: 40px;
          width: 80%;
        }

        .buttons-container {
          display: flex;
          justify-content: center;
          gap: 20px;
        }

        button {
          padding: 10px 20px;
          background-color: #11a1b0;
          color: white;
          border: none;
          border-radius: 31px;
          cursor: pointer;
          transition: background-color 0.3s;
        }

        button:hover {
          background-color: #0c7f86;
        }
      `}</style>
    </div>
  );
};

export default GroupCompanies;
